/**
 * Challenge Token Helpers — Feb 2026
 * ==================================
 *
 * The AvA occasionally emits `[CHALLENGE:slug]` tokens inside its
 * text reply to reference a real-world challenge from the 20-challenge
 * library. The chat UI renders these tokens as tappable chips that
 * route to `/challenges/:slug`.
 *
 * Pure helpers only — no React, no side effects — so they can be
 * unit-tested in isolation and reused by any future surface that
 * shows AvA text.
 */

export const CHALLENGE_TOKEN_RE = /\[CHALLENGE:([a-z0-9][a-z0-9-_]{1,60})\]/gi;

export const extractChallengeTokens = (text) => {
  if (!text || typeof text !== 'string') return [];
  const seen = new Set();
  const out = [];
  let m;
  CHALLENGE_TOKEN_RE.lastIndex = 0;
  while ((m = CHALLENGE_TOKEN_RE.exec(text)) !== null) {
    const slug = m[1].toLowerCase();
    if (!seen.has(slug)) { seen.add(slug); out.push(slug); }
  }
  return out;
};

export const prettySlug = (slug) =>
  slug.replace(/[-_]+/g, ' ').replace(/\b\w/g, (c) => c.toUpperCase());
